import React from "react";
import UserForm from './UserForm';
import LaunchConfig from './LaunchConfig';
import AddOns from './AddOns';
import Flight from './Flight';
import { Transition } from 'react-transition-group';
import { transitionStyles, duration, defaultStyle } from './constants';

export default class FlightList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ...props,
      active: false,
      filter: true
    };
  }

  cb = (ll) => {
    this.setState({active: ll.id});
    this.props.callback({field: 'flight', value: ll});
  }

  item = (ll) => {
    const active = (this.state.active == ll.id) ? ' active' : '';
    return(
      <div className={"launch"+active} onClick={() => {this.cb(ll)}}>
        <Flight {...ll} />
      </div>
    )
  }

  unfilter =  () =>{
    this.setState({
      filter: false
    })
  }

  render() {
    const results = this.filterResults();
    return (
      <div className="mt-5">
      {(results.length > 0) ?
      (<>
        {(this.state.filter) ?
          (<p>Here is a list of launch opportunities to match your selected criteria. <br />Should you want to discuss more options, please do not hesitate to <a href="mailto:sales@dorbit.space">get in touch with us</a>.</p>)
          :
          (<p>Here is the complete list of launch opportunities. <br />Should you want to discuss more options, please do not hesitate to <a href="mailto:sales@dorbit.space">get in touch with us</a>.</p>)}
        {results.map((ll, ix) => {
          return(
            <div key={ix} className="mb-3">{this.item(ll)}</div>
          )
        })
        }
        {(this.state.filter) &&
          <div><a href="#" onClick={()=>{this.unfilter()}}>View all scheduled launches</a></div>
        }
      </>)
      :
      (<>The system was not able to find a match for your mission requirements. Feel free to <a href="mailto:sales@dorbit.space">get in touch with us</a> to find a solution that
can suit you! <a href="#" className="btn btn-small btn-primary" onClick={()=>{this.unfilter()}}>View all scheduled launches</a></>)
      }
      </div>
    );
  }


  filterResults = () => {
    const today = this.formatYYYYMM();
    const results = this.state.flights.filter((launch) => {
      console.log(launch);
      if(parseInt(launch.launch_date_m) < 10)
        launch.launch_date_m = "0" + String(parseInt(launch.launch_date_m));
      let launchDate = parseInt(String(launch.launch_date_y) + String(launch.launch_date_m));
      if(
        (launchDate >= today)
          &&
        (
          (launch.destination == this.props.formData.destination)||
          (!this.props.formData.destination)||
          (!this.state.filter)
        )
          &&
        (
          (launch.inclination == this.props.formData.inclination)||
          (this.props.formData.destination == 'SSO')||
          (!this.state.filter)
        )
        &&
      (
        (launch['ll-sel'].includes(this.props.formData.ltanltdn))||
        (this.props.formData.destination == 'LEO')||
        (this.props.formData.ltanltdn == 'any')||
        (!this.state.filter)
      )
        &&
      (
        (
          /*(
            (launch['alt-max'] <= this.props.formData.altitude_max)&&
            (launch['alt-max'] >= this.props.formData.altitude_min)
          )||
          (
            (launch['alt-min'] <= this.props.formData.altitude_max)&&
            (launch['alt-min'] >= this.props.formData.altitude_min)
          )*/
          (
            (launch['alt-max'] >= this.props.formData.altitude)
            &&
            (launch['alt-min'] <= this.props.formData.altitude)
          )
        )||
        (!this.state.filter)
      )
      ){
        return true;
      }
    })
    return results;
  }

  formatYYYYMM = (dd = new Date) => {
    const d = new Date(dd);
    const ye = new Intl.DateTimeFormat('it', { year: 'numeric' }).format(d);
    const mo = new Intl.DateTimeFormat('it', { month: '2-digit' }).format(d);
    const da = new Intl.DateTimeFormat('it', { day: '2-digit' }).format(d);
    const today = String(ye) + String(mo);
    return parseInt(today)
  }
}
